import {Box, Dialog, DialogContent, DialogTitle, Stack, styled} from '@mui/material';

const StyledDialog = styled(Dialog)`
	max-width: 484px;
	margin: auto;

	& .MuiDialog-paper {
		margin: 16px;
	}

	${({theme}) => theme.breakpoints.up('sm')} {
		& .MuiDialog-paper {
			margin: 32px;
		}
	}
`;

const StyledDialogHeader = styled(DialogTitle)`
	padding: 16px 24px;
	background-color: ${({theme}) => theme.palette.primary.main};
	color: ${({theme}) => theme.palette.common.white};
`;

const ImageContainer = styled(Box)`
	margin: 16px auto 0px;
	width: fit-content;
`;

const StyledCarouselContainer = styled(Box)`
	height: 100%;
	display: flex;
	flex-direction: column;

	#outer-container,
	#outer-container > #inner-container {
		flex: 1;
	}

	#outer-container > #inner-container,
	#outer-container > #inner-container > #slide-container {
		height: 100% !important;
	}

	#outer-container > #inner-container > #slide-container > div.slide {
		height: calc(100% - 32px);
		flex-basis: 100%;
	}

	#dots-container {
		margin-top: 16px;
		padding-inline: 11px;
	}
`;

const StyledDialogContent = styled(DialogContent)`
	height: 100%;
	margin: 16px;
	padding: 16px;
	border-radius: 8px;
	background-color: ${({theme}) => theme.palette.common.white};
`;

const StyledButtonContainer = styled(Stack)`
	background-color: white;
	padding: 16px;
	gap: 8px;
	border-top: 1px solid ${({theme}) => theme.palette.other.outlineBorder};
`;

export {
	StyledDialog,
	StyledDialogHeader,
	ImageContainer,
	StyledCarouselContainer,
	StyledDialogContent,
	StyledButtonContainer,
};
